import { combineReducers } from 'redux';
import { thangDiemReducer } from './thangDiemReducer';
export const soDiemReducerWrapper = combineReducers({
    thangDiem: thangDiemReducer,
})
